import type { Surcharge } from "./const.js";

/**
 * 車費成本合計 = 基礎成本 + 所有固定金額加購項。
 * 純函式，前後端共用；忽略非有限數字的加購金額。
 */
export function totalCost(base: number, surcharges: Surcharge[] = []): number {
  return surcharges.reduce((sum, s) => sum + (Number.isFinite(s.amount) ? s.amount : 0), base);
}
